import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M14.61 1.505a1.5 1.5 0 0 0-1.5 1.5V6H7.375A5.375 5.375 0 0 0 2 11.375v5.875a2.25 2.25 0 0 0 2.25 2.25h15.5A2.25 2.25 0 0 0 22 17.25v-6C22 8.35 19.65 6 16.75 6h-2.14V4.502H16.5a1.499 1.499 0 0 0 0-2.997zM16.75 7.5H11.1a5.36 5.36 0 0 1 1.65 3.875V18h7a.75.75 0 0 0 .75-.75v-6a3.75 3.75 0 0 0-3.75-3.75m-5.5 3.875V18h-7a.75.75 0 0 1-.75-.75v-5.875a3.875 3.875 0 0 1 7.75 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }